<template>
  <div class="login">
    <div class="login__inner">
      <Sidebar />
      <div class="login__rs">
        <div class="login__logo-intro--above">
          <img src="@/assets/cia_logo_white.svg" alt="CIA" class="mb-5">
        </div>
        <ResetPassword />
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from './../components/Login/Sidebar.vue';
import ResetPassword from './../components/Login/ResetPassword.vue';

export default {
  name: 'reset-password',
  components: {
    Sidebar,
    ResetPassword,
  },
};
</script>
